import {FC} from 'react'
import '../../styles/scss/modal-learn-card/modal-learn-card.scss'
import {Button, Card, Col, Divider, Flex, Modal, Row, Typography} from 'antd'
import {WordList} from "../../shared/types/api";
import {goToExercisePage} from "../utils/goToPage";
import {NavigationPages} from "../../common/navigation/navigation-pages";
import {useNavigate} from "react-router-dom";
import {
    AppstoreOutlined,
    FontSizeOutlined,
    IdcardOutlined,
    QuestionCircleOutlined,
    ReadOutlined,
    TableOutlined
} from "@ant-design/icons";
import {TbCards} from "react-icons/tb";

interface LearnCardDialogProps {
    wordList: WordList,
    close: () => void,
    open: boolean;
}

const { Text, Title } = Typography;

const ICON_BOX = { size: 44, radius: 10, bg: '#f5f5f5', icon: 24 };

// @ts-ignore
const IconBox = ({ children }) => (
    <Flex
        align="center"
        justify="center"
        style={{
            width: ICON_BOX.size,
            height: ICON_BOX.size,
            borderRadius: ICON_BOX.radius,
            background: ICON_BOX.bg,
            lineHeight: 0,
            flex: '0 0 auto',
        }}
    >
        {children}
    </Flex>
);

const LearnCardDialog: FC<LearnCardDialogProps> = ({close, open, wordList}) => {

    const navigate = useNavigate()

    const options = [
        {
            key: 'cards',
            title: 'Карточки',
            desc: 'Запоминай в формате пар “слово–перевод”',
            icon: (
                <IconBox>
                    <TbCards style={{ fontSize: ICON_BOX.icon }} />
                </IconBox>
            ),
            onClick: () => goToExercisePage(NavigationPages.CARDS, navigate, wordList),
        },
        {
            key: 'tests',
            title: 'Тесты',
            desc: 'Выбери 1 вариант из 4',
            icon: (
                <IconBox>
                    <QuestionCircleOutlined style={{ fontSize: ICON_BOX.icon }} />
                </IconBox>
            ),
            onClick: () => goToExercisePage(NavigationPages.TEST, navigate, wordList),
        },
        {
            key: 'fill-gaps',
            title: 'Заполни пропуски',
            desc: 'Впиши недостающие буквы в слове',
            icon: (
                <IconBox>
                    <FontSizeOutlined style={{ fontSize: ICON_BOX.icon }} />
                </IconBox>
            ),
            onClick: () => goToExercisePage(NavigationPages.GUESS_WORD, navigate, wordList),
        },
        {
            key: 'word-search',
            title: 'Филворды',
            desc: 'Найди слова в сетке как в кроссворде',
            icon: (
                <IconBox>
                    <TableOutlined style={{ fontSize: ICON_BOX.icon }} />
                </IconBox>
            ),
            onClick: () => goToExercisePage(NavigationPages.FILL_WORDS, navigate, wordList),
        },
    ];



    return (
        <Modal
            open={open}
            onCancel={close}
            destroyOnClose
            centered
            width={560}
            title={
                <Flex vertical gap={4}>
                    <Title level={4} style={{ margin: 0 }}>Как будем учить?</Title>
                    <Text type="secondary">Выбери формат тренировки</Text>
                </Flex>
            }
            footer={[
            ]}
        >
            <Row gutter={[12, 12]}>
                {options.map((opt) => (
                    <Col key={opt.key} xs={24} sm={12}>
                        <Card
                            hoverable
                            onClick={opt.onClick}
                            style={{ height: '100%' }}
                        >
                            <Flex align="center" gap={12}>
                                <Flex
                                    align="center"
                                    justify="center"
                                    style={{
                                        width: 44,
                                        height: 44,
                                        borderRadius: 10,
                                        background: 'var(--color-bg-hover)',
                                        fontSize: 22,
                                        lineHeight: 0
                                    }}
                                >
                                    {opt.icon}
                                </Flex>
                                <Flex vertical style={{ minWidth: 0 }}>
                                    <Text strong ellipsis>{opt.title}</Text>
                                    <Text type="secondary" ellipsis>{opt.desc}</Text>
                                </Flex>
                            </Flex>
                        </Card>
                    </Col>
                ))}
            </Row>

            <Divider style={{ margin: '16px 0' }} />

            {/* Подсказка */}
            <Text type="secondary">Можно выбрать любой формат — вернуться к выбору всегда можно позже.</Text>
        </Modal>
    )
}

export default LearnCardDialog
